import React from 'react'
import HmVideo from '../HmVideo'

const Home = () => {
  return (
    <div className='hme'>
       <div className='hm-video'> 
            <div class="vertical-badge lft">
              <span>We Accept Digital Payments Only</span>
            </div>       
            <div class="vertical-badge rt">
              <span>We Accept Cashless  Payments Only</span>
            </div>
        <HmVideo videoId="3DXDQ9AQKjw" />        
       </div>
    </div>
  )
}

export default Home